import React from "react";
import ResetPassword from "../../components/Auth/ResetPasswordLayer";
import "../../custom.css";

const ResetPasswordPage = () => {
  return (
    <>

      {/* Forgotpassword */}
      <ResetPassword />

    </>
  );
};

export default ResetPasswordPage; 
